module.exports = __webpack_public_path__ + "img/09d68f04c0b1f3ab67681fce7a65b3f8.png";